import React from 'react';
import Hero from '../components/Hero';
import ContactForm from './ContactForm';

const PizzaInTheOven = () => {
  return (
    <div className="pizza-in-oven-container">
    <Hero text="פיצות בטאבון לכל סוגי האירועים" />
    <div className="description">
  <p><strong>פיצה בהתאמה אישית, לכל אירוע</strong>
   -אנחנו מאמינים שכל אירוע הוא ייחודי, בדיוק כמו כל פיצה. בין אם אתם חוגגים יום הולדת אינטימי או מסיבה גדולה, אנחנו נשמח להתאים את התפריט לטעמים שלכם
  </p>
  <p><strong>טאבון פחמים, טעם אותנטי</strong>
  -הפיצות שלנו נאפות בטאבון פחמים מסורתי, מה שמעניק להן טעם עשיר ועשוי. כל ביס הוא חגיגה לחיך
  </p>
  <p><strong>מוצרלה איכותית, טעם בלתי נשכח</strong>
  -רק גבינת מוצרלה איכותית מגיעה אל הפיצות שלנו. כל נגיסה היא חגיגה של גבינה מותכת וטעימה
  </p>
  <p><strong>תוספות טריות, שילובים מנצחים</strong>
  -בחרו מתוך מגוון רחב של תוספות טריות ואיכותיות, או תנו לשף שלנו להפתיע אתכם עם שילובים מנצחים
  </p>
  <p><strong>חומרי גלם מהטבע, טעם אמיתי</strong>
  -אנחנו משתמשים רק בחומרי גלם טריים ואיכותיים, שנבחרים בקפידה. כל עגבניה, כל עלה בזיליקום - הכל בשביל הטעם המושלם
  </p>
  <p> <strong>תוספות מיוחדות, חוויה קולינרית</strong>
  -תנו לטעם להתפוצץ לכם בפה עם התוספות המיוחדות שלנו: ריבת בצל מתקתקה, ריבת עגבניות שרי עסיסיות, קונפי ארטישוק מעודן, שום קונפי ועוד
  </p>
  </div>
  <ContactForm />
  <a href="tel:0526996037" className="call-button">
      !התקשרו לשמוע עוד פרטים
      </a>
  </div>
  );
};

export default PizzaInTheOven;
